import React, { useState } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";

const StaticCheckboxWithDeclaration = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <Card className="mt-2 mb-0 dynamicFormcards ms-3 me-3" style={{ width: "97%" }} id="declarationCheck"
    >
      <Row className="mt-3 align-items-center">
        {/* Left Section: Checkbox and Declaration */}
        <Col
          xs={10}
          className="d-flex align-items-start"
          style={{ justifyContent: "flex-start", textAlign: "left" }}
        >
          {/* Toggle switch */}
          <Form.Check
            type="checkbox"
            onChange={handleCheckboxChange}
            checked={isChecked}
          />
          <label htmlFor="declaration" style={{ fontSize: "14px" }}>
            I hereby declare that the information provided is true to the best of my knowledge.
          </label>
        </Col>

        {/* Right Section: Image */}
        <Col xs={2} className="text-end">
          <img
            src="https://via.placeholder.com/100"
            alt="Sign"
            style={{ width: "100px", height: "auto", cursor: "pointer" }}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default StaticCheckboxWithDeclaration;
